// extracted by css-extract-rspack-plugin
export default {"applePayContainer":"ApplePay__apple-pay-container--AKxSx"};